import { useEffect } from 'react'
import config from 'configs'
import { useStores } from './useStores'

declare global {
  interface Window {
    heap: {
      identify: (email: string) => void
    }
  }
}

export function useHeap(): void {
  const { authStore } = useStores()
  const { userDetail } = authStore

  useEffect(() => {
    if (!config.heapId) {
      return
    }

    // Delay loading Heap Analytics until after page load for better performance
    const loadHeap = () => {
      const script = document?.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.innerHTML = `window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src="https://cdn.heapanalytics.com/js/heap-"+e+".js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r,a);for(var n=function(e){return function(){heap?.push && heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],o=0;o<p.length;o++)heap[p[o]]=n(p[o])};
      heap.load("${config.heapId}");`
      document.head.appendChild(script)
    }

    // Load Heap after page is fully loaded or after a delay
    if (document.readyState === 'complete') {
      setTimeout(loadHeap, 1500) // 1.5 second delay
    } else {
      window.addEventListener('load', () => {
        setTimeout(loadHeap, 1500)
      })
    }
  }, [])

  useEffect(() => {
    if (userDetail?.email && window && window?.heap && window?.heap?.identify) {
      window?.heap?.identify(userDetail.email)
    }
  }, [userDetail?.email])
}
